import { ItemStockButtonState } from './ItemStockButtonState';

let _itemStockButtonViewLocalize: Record<ItemStockButtonState, string> | undefined;

export function getItemStockButtonViewLocalize(): Record<ItemStockButtonState, string> {
  if (!_itemStockButtonViewLocalize) {
    _itemStockButtonViewLocalize = {
      [ItemStockButtonState.SOLD_OUT]: $localize`:@@ideal-item-stock-button-view.sold-out:Sold Out`,
      [ItemStockButtonState.IN_STOCK]: $localize`:@@ideal-item-stock-button-view.in-stock:In Stock`,
      [ItemStockButtonState.IN_STORE]: $localize`:@@ideal-item-stock-button-view.in-store:In Store`,
      [ItemStockButtonState.BACK_ORDERED]: $localize`:@@ideal-item-stock-button-view.back-ordered:On Back-order`,
      [ItemStockButtonState.ORDERABLE]: $localize`:@@ideal-item-stock-button-view.orderable:Can Back-order`,
      [ItemStockButtonState.WAREHOUSE]: $localize`:@@ideal-item-stock-button-view.warehouse:Warehouse`,
    };
  }
  return _itemStockButtonViewLocalize;
}
